import * as React from 'react';
import { compose, pure } from 'recompose';
import MuiCheckbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { createStyles, withStyles } from '@material-ui/styles';
import { transition } from '@topconagriculture/theme';
const styles = (theme) => createStyles({
    default: {
        width: 'auto',
        height: 'auto',
        color: theme.color.font.dark,
        marginRight: 5,
        transition: transition(50),
    },
    checked: {
        color: theme.color.grey.darkest,
    },
    root: {
        margin: 0,
    },
});
const Checkbox = (props) => {
    const { label, classes, input, testId = 'Checkbox', ...others } = props;
    const checkBoxEl = (React.createElement(MuiCheckbox, Object.assign({ "data-testid": testId, color: 'default', className: classes.default, checked: input ? !!input.value : false, onChange: input && input.onChange }, others)));
    const checkboxElWithLabel = React.createElement(FormControlLabel, { control: checkBoxEl, label: label, classes: { root: classes.root } });
    return React.createElement("div", null, label ? checkboxElWithLabel : checkBoxEl);
};
const ComposedCheckbox = compose(withStyles(styles, { withTheme: true }), pure)(Checkbox);
ComposedCheckbox.displayName = 'Checkbox';
export default ComposedCheckbox;
//# sourceMappingURL=Checkbox.js.map